export const deleteEmptyServices = (services: Record<string, number[]>) => {
	const activeServices = JSON.parse(JSON.stringify(services));
	Object.keys(activeServices).forEach((key) => {
		if (!activeServices[key].length) {
			delete activeServices[key];
		}
	});
	return activeServices;
};
